import React from 'react';
import useMedia from 'use-media';
import { Label } from '../atoms/label';

export const Confirmheader = (props) => {

    const isWideTablet = useMedia({ maxWidth: '960px' });
    const isWidePhone = useMedia({ maxWidth: '480px' });

    return (

        <div style={styles.heading} style={isWideTablet ? styles.heading2 : styles.heading}>
            <Label label={props.label} style={isWideTablet ? styles.headingText2 : styles.headingText} />
        </div>

    );
}
const styles = {
    heading: {
        fontSize: "1.2rem",
        backgroundColor: "rgb(111, 111, 111)",
        width: "100%",
        height: "40px",
        display: "flex",
        justifyContent: "space-around",
        marginBottom: "50px",
        color: "white",
    },
    heading2: {
        fontSize: "1.2rem",
        backgroundColor: "rgb(111, 111, 111)",
        width: "100%",
        height: "50px",
        display: "flex",
        justifyContent: "space-around",
        marginBottom: "30px",
        color: "white",
    },
    headingText: {
        lineHeight: "40px",
        display: "inline-block",
        margin: "0px 0px 0px 20px",
        width: "100%",
        textAlign: "left",
    },
    headingText2: {
        lineHeight: "50px",
        display: "inline-block",
        margin: "0px",
        width: "90%",
        textAlign: "left",
        fontWeight: "700",
    },
}